define([
    "skylark-utils/velm"
], function(velm) {
    return velm;
});
